var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	96510: {
		fallback: () => (() => (__webpack_require__(40961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	63941: {
		fallback: () => (() => (__webpack_require__(56347))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router",

	},
	20562: {
		fallback: () => (() => (__webpack_require__(96540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	85277: {
		fallback: () => (() => (__webpack_require__(68238))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.0.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "redux",

	},
	85969: {
		fallback: () => (() => (__webpack_require__(61225))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.1.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",

	},
	41056: {
		fallback: () => (() => (__webpack_require__(54625))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.0.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	68186: {
		fallback: () => (() => (__webpack_require__(27701))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.1.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "redux-saga",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [96510,63941,20562,85277];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"58": [
		85969
	],
	"99": [
		41056
	],
	"204": [
		85969
	],
	"244": [
		85969
	],
	"327": [
		85969,
		41056
	],
	"348": [
		85969,
		41056
	],
	"381": [
		85969,
		41056
	],
	"434": [
		85969,
		41056
	],
	"439": [
		96510,
		63941,
		20562,
		85277
	],
	"521": [
		85969
	],
	"634": [
		85969,
		41056,
		68186
	],
	"913": [
		85969
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}